import { useQuery } from "@tanstack/react-query";

import { usePageSettings } from "../contexts/PageSettingsContext";

const useFetchWebHostingPlans = () => {
	const { currency } = usePageSettings();

	const fetchWebHostingPlans = async () => {
		try {
			const response = await fetch(
				`${process.env.GATSBY_PLANS_ENDPOINT}currency=${currency}&service=webhosting&cycle=annually`
			);

			if (!response.ok) {
				throw new Error("Failed to fetch data");
			}

			const data = await response.json();
			return data;
		} catch (error) {
			console.error("Error fetching web hosting plans:", error);
			throw error;
		}
	};

	return useQuery({
		queryKey: ["webHostingPlans", currency],
		queryFn: fetchWebHostingPlans,
		refetchOnWindowFocus: false,
		enabled: true,
	});
};

export default useFetchWebHostingPlans;
